/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Start_LabelInputs */



/**
* | output |
* | --- |
* | "Start spell check" |
*
* @param {Spellcheck_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_start_label = /** @type {((inputs?: Spellcheck_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrer la verification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtschreibprüfung starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia il controllo ortografico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать проверку орфографии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar la revisión ortográfica")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始拼写检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェックを開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी जाँच शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar verificação ortográfica")
	return /** @type {LocalizedString} */ ("Start spell check")
});